/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type MarkRiskResultsFalsePositiveRequestBody = {
  /**
   * Optional free-text reason for the dismissal.
   */
  reason?: string | undefined;
  /**
   * IDs of the risk results to mark as false positive.
   */
  resultIds: Array<string>;
};

/** @internal */
export type MarkRiskResultsFalsePositiveRequestBody$Outbound = {
  reason?: string | undefined;
  result_ids: Array<string>;
};

/** @internal */
export const MarkRiskResultsFalsePositiveRequestBody$outboundSchema:
  z.ZodMiniType<
    MarkRiskResultsFalsePositiveRequestBody$Outbound,
    MarkRiskResultsFalsePositiveRequestBody
  > = z.pipe(
    z.object({
      reason: z.optional(z.string()),
      resultIds: z.array(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        resultIds: "result_ids",
      });
    }),
  );

export function markRiskResultsFalsePositiveRequestBodyToJSON(
  markRiskResultsFalsePositiveRequestBody:
    MarkRiskResultsFalsePositiveRequestBody,
): string {
  return JSON.stringify(
    MarkRiskResultsFalsePositiveRequestBody$outboundSchema.parse(
      markRiskResultsFalsePositiveRequestBody,
    ),
  );
}
